(function() {
  'use strict';

  function isReserveEligibleVariant(variant) {
    if (!variant) return false;
    if (variant.inventory_management !== 'shopify') return false;
    var quantity = Number(variant.inventory_quantity || 0);
    return quantity <= 0 && variant.inventory_policy === 'deny';
  }

  function isVariantSoldOut(variant) {
    if (!variant) return true;
    if (isReserveEligibleVariant(variant)) return false;
    if (variant.available === false) return true;
    if (variant.inventory_management === 'shopify') {
      var quantity = Number(variant.inventory_quantity || 0);
      if (quantity <= 0 && variant.inventory_policy === 'deny') {
        return true;
      }
    }
    return false;
  }

  function setCartButtonAvailability(button, variant) {
    if (!button) return;

    var textElement = button.querySelector('.mobile-product-bar__add-text');
    var reserveEligible = isReserveEligibleVariant(variant);
    var soldOut = isVariantSoldOut(variant);

    delete button.dataset.soldOut;

    if (reserveEligible) {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      button.setAttribute('data-reserve-product', '');
      button.classList.add('mobile-product-bar__add-button--reserve');
      if (textElement) {
        textElement.textContent = button.dataset.reserveLabel || Theme?.translations?.reserve_now || 'Reserve now';
      }
      return;
    }

    button.removeAttribute('data-reserve-product');
    button.classList.remove('mobile-product-bar__add-button--reserve');

    if (soldOut) {
      button.disabled = true;
      button.dataset.soldOut = 'true';
      button.setAttribute('aria-disabled', 'true');
      if (textElement) {
        textElement.textContent = Theme?.translations?.sold_out || 'Sold out';
      }
      return;
    }

    button.disabled = false;
    button.removeAttribute('aria-disabled');
    if (textElement) {
      textElement.textContent = button.dataset.defaultLabel || Theme?.translations?.add_to_cart || 'Add to cart';
    }
  }

  function replaceContainerHtml(container, html) {
    container.replaceChildren();
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    for (const node of doc.body.childNodes) {
      container.appendChild(node.cloneNode(true));
    }
  }
  
  function initParametersStructure() {
    const variantsEl = document.querySelector('[data-variants]');
    if (!variantsEl) return false;
    
    const section = variantsEl.closest('.shopify-section');
    const accordionRows = section ? section.querySelectorAll('accordion-custom') : document.querySelectorAll('accordion-custom');
    
    let parametersRow = null;
    for (const row of accordionRows) {
      const summary = row.querySelector('summary.details__header');
      if (summary && summary.textContent.trim().includes('Parameters')) {
        parametersRow = row;
        break;
      }
    }
    
    if (!parametersRow) return false;
    
    parametersRow.classList.add('product-parameters');
    const detailsContent = parametersRow.querySelector('.details-content');
    if (!detailsContent) return false;
    
    if (detailsContent.querySelector('.parameters-list')) {
      return true;
    }
    
    const staticHTML = `
      <div class="parameters-list">
        <div class="parameter-item" data-param="size">
          <span class="parameter-label">Size</span>
          <span class="parameter-value skeleton"></span>
        </div>
        <div class="parameter-item" data-param="material">
          <span class="parameter-label">Material</span>
          <span class="parameter-value skeleton"></span>
        </div>
        <div class="parameter-item" data-param="collection">
          <span class="parameter-label">Collection</span>
          <span class="parameter-value skeleton"></span>
        </div>
        <div class="parameter-item" data-param="brand">
          <span class="parameter-label">Brand</span>
          <span class="parameter-value skeleton"></span>
        </div>
        <div class="parameter-item" data-param="sku">
          <span class="parameter-label">SKU</span>
          <span class="parameter-value skeleton"></span>
        </div>
      </div>
    `;
    
    const textBlock = detailsContent.querySelector('p, [class*="text"], .rte');
    if (textBlock) {
      replaceContainerHtml(textBlock, staticHTML);
    } else {
      replaceContainerHtml(detailsContent, staticHTML);
    }
    
    return true;
  }
  
  function updateParameterValues(params) {
    const variantsEl = document.querySelector('[data-variants]');
    if (!variantsEl) return;
    
    const section = variantsEl.closest('.shopify-section');
    const accordionRows = section ? section.querySelectorAll('accordion-custom') : document.querySelectorAll('accordion-custom');
    
    let parametersRow = null;
    for (const row of accordionRows) {
      const summary = row.querySelector('summary.details__header');
      if (summary && summary.textContent.trim().includes('Parameters')) {
        parametersRow = row;
        break;
      }
    }
    
    if (!parametersRow) return;
    
    const detailsContent = parametersRow.querySelector('.details-content');
    if (!detailsContent) return;
    
    const { size, material, brand, collection, sku } = params;
    
    const sizeItem = detailsContent.querySelector('[data-param="size"]');
    if (sizeItem) {
      const sizeValue = sizeItem.querySelector('.parameter-value');
      if (sizeValue) {
        sizeItem.style.display = size ? 'flex' : 'none';
        sizeValue.textContent = size || '';
        sizeValue.classList.remove('skeleton');
      }
    }
    
    const materialItem = detailsContent.querySelector('[data-param="material"]');
    if (materialItem) {
      const materialValue = materialItem.querySelector('.parameter-value');
      if (materialValue) {
        materialItem.style.display = material ? 'flex' : 'none';
        materialValue.textContent = material || '';
        materialValue.classList.remove('skeleton');
      }
    }
    
    const collectionItem = detailsContent.querySelector('[data-param="collection"]');
    if (collectionItem) {
      const collectionValue = collectionItem.querySelector('.parameter-value');
      if (collectionValue) {
        if (collection && collection.title) {
          collectionItem.style.display = 'flex';
          collectionValue.replaceChildren();
          const link = document.createElement('a');
          link.href = collection.url || '#';
          link.className = 'collection-link collection-link-multiline';
          link.textContent = collection.title;
          collectionValue.appendChild(link);
        } else {
          collectionItem.style.display = 'none';
          collectionValue.replaceChildren();
        }
        collectionValue.classList.remove('skeleton');
      }
    }
    
    const brandItem = detailsContent.querySelector('[data-param="brand"]');
    if (brandItem) {
      const brandValue = brandItem.querySelector('.parameter-value');
      if (brandValue) {
        brandItem.style.display = brand ? 'flex' : 'none';
        brandValue.textContent = brand || '';
        brandValue.classList.remove('skeleton');
      }
    }
    
    const skuItem = detailsContent.querySelector('[data-param="sku"]');
    if (skuItem) {
      const skuValue = skuItem.querySelector('.parameter-value');
      if (skuValue) {
        skuItem.style.display = sku ? 'flex' : 'none';
        skuValue.textContent = sku || '';
        skuValue.classList.remove('skeleton');
      }
    }
  }
  
  function updateParameters(variantId, fullVariantData) {
    try {
      const variantsEl = document.querySelector('[data-variants]');
      if (!variantsEl) {
        return;
      }
      
      const variants = JSON.parse(variantsEl.textContent || '[]');
      const variant = variants.find(v => String(v.id) === String(variantId));
      if (!variant) {
        return;
      }
      
      // Объединяем данные из [data-variants] с полными данными варианта
      // Приоритет у полных данных (fullVariantData), затем данные из [data-variants]
      const variantWithFullData = fullVariantData ? { ...variant, ...fullVariantData } : variant;
      
      if (!initParametersStructure()) {
        return;
      }
      
      const selectedSize = getSelectedSize();
      const productMetafields = getProductMetafields();
      const collectionData = getCollectionData();
      
      let sizeValue = '';
      if (variant.size && variant.size !== null && String(variant.size).trim() !== '' && variant.size !== '0') {
        sizeValue = variant.size;
      } else if (selectedSize && selectedSize !== '0') {
        sizeValue = selectedSize;
      } else if (productMetafields.size && productMetafields.size !== '3' && productMetafields.size !== '0' && productMetafields.size.trim() !== '') {
        sizeValue = productMetafields.size;
      }
      
      const materialValue = (variant.material && variant.material !== null && String(variant.material).trim() !== '') 
        ? variant.material 
        : (productMetafields.material || '');
      
      const brandValue = (variant.brand && variant.brand !== null && String(variant.brand).trim() !== '') 
        ? variant.brand 
        : (productMetafields.brand || '');
      
      const skuValue = variant.sku && String(variant.sku).trim() !== '' 
        ? String(variant.sku).trim() 
        : '';
      
      updateParameterValues({
        size: sizeValue,
        material: materialValue,
        brand: brandValue,
        collection: collectionData,
        sku: skuValue
      });
      
      // Обновляем кнопку преордера
      updateMobileBarButton(variantWithFullData);
      
    } catch (error) {
      console.error('Error updating parameters:', error);
    }
  }
  
  function updateInventoryFromHTML(htmlData) {
    if (!htmlData) return;
    
    const currentContainer = document.querySelector('.product-inventory-badges-container');
    if (!currentContainer) return;
    
    const newContainer = htmlData.querySelector('.product-inventory-badges-container');
    if (!newContainer) {
      const newInventory = htmlData.querySelector('product-inventory');
      const currentInventory = currentContainer.querySelector('product-inventory');
      if (newInventory && currentInventory) {
        currentInventory.outerHTML = newInventory.outerHTML;
      }
      return;
    }
    
    replaceContainerHtml(currentContainer, newContainer.innerHTML);
  }
  
  function updateButtonFromHTML(htmlData) {
    if (!htmlData) return;
    
    const newButtonWrapper = htmlData.querySelector('.product-details-cart-button-wrapper');
    if (!newButtonWrapper) return;
    
    const currentDesktopContainer = document.querySelector('.add-to-cart-button--desktop');
    if (!currentDesktopContainer) return;
    
    const currentButtonWrapper = currentDesktopContainer.querySelector('.product-details-cart-button-wrapper');
    if (!currentButtonWrapper) return;

    const currentAddWrapper = currentButtonWrapper.querySelector('.mobile-product-bar__add-button-wrapper');
    const newAddWrapper = newButtonWrapper.querySelector('.mobile-product-bar__add-button-wrapper');
    const currentButton = currentButtonWrapper.querySelector('.mobile-product-bar__add-button');
    const newButton = newButtonWrapper.querySelector('.mobile-product-bar__add-button');
    const currentText = currentButton ? currentButton.querySelector('.mobile-product-bar__add-text') : null;
    const newText = newButton ? newButton.querySelector('.mobile-product-bar__add-text') : null;
    const currentProductForm = currentButtonWrapper.closest('product-form-component');
    const currentDelivery = currentProductForm
      ? currentProductForm.querySelector('.product-details__delivery-pickup--after-cart')
      : null;
    const newDelivery = htmlData.querySelector('.product-details__delivery-pickup--after-cart');

    if (currentButtonWrapper.dataset.productId !== newButtonWrapper.dataset.productId) {
      currentButtonWrapper.dataset.productId = newButtonWrapper.dataset.productId || currentButtonWrapper.dataset.productId || '';
    }
    if (currentButtonWrapper.dataset.variantId !== newButtonWrapper.dataset.variantId) {
      currentButtonWrapper.dataset.variantId = newButtonWrapper.dataset.variantId || currentButtonWrapper.dataset.variantId || '';
    }

    if (currentAddWrapper && newAddWrapper) {
      currentAddWrapper.dataset.productId = newAddWrapper.dataset.productId || currentAddWrapper.dataset.productId || '';
      currentAddWrapper.dataset.variantId = newAddWrapper.dataset.variantId || currentAddWrapper.dataset.variantId || '';
    }

    if (currentButton && newButton) {
      currentButton.dataset.productId = newButton.dataset.productId || currentButton.dataset.productId || '';
      currentButton.dataset.variantId = newButton.dataset.variantId || currentButton.dataset.variantId || '';
      currentButton.dataset.productTitle = newButton.dataset.productTitle || currentButton.dataset.productTitle || '';
      currentButton.dataset.productImage = newButton.dataset.productImage || currentButton.dataset.productImage || '';
      currentButton.dataset.productPath = newButton.dataset.productPath || currentButton.dataset.productPath || '';
      currentButton.dataset.productUrl = newButton.dataset.productUrl || currentButton.dataset.productUrl || '';
      currentButton.dataset.variantSku = newButton.dataset.variantSku || currentButton.dataset.variantSku || '';
      currentButton.disabled = newButton.disabled;
      currentButton.toggleAttribute('aria-disabled', newButton.hasAttribute('aria-disabled'));
      if (newButton.dataset.soldOut) {
        currentButton.dataset.soldOut = newButton.dataset.soldOut;
      } else {
        delete currentButton.dataset.soldOut;
      }
      currentButton.removeAttribute('data-reserve-product');
      currentButton.classList.remove('mobile-product-bar__add-button--reserve');
    }

    if (currentText && newText) {
      currentText.textContent = newText.textContent;
    }

    if (currentDelivery && newDelivery && currentDelivery.textContent !== newDelivery.textContent) {
      replaceContainerHtml(currentDelivery, newDelivery.innerHTML);
    }
  }
  
  function updateMobileBarButton(variant) {
    if (!variant) return;
    
    updateButtonInContainer('[data-mobile-bar]', variant);
    updateButtonInContainer('.product-details-cart-button-wrapper', variant);
  }
  
  function updateButtonInContainer(containerSelector, variant) {
    const container = document.querySelector(containerSelector);
    if (!container) return;
    
    const wrapper = container.querySelector('.mobile-product-bar__add-button-wrapper');
    const button = container.querySelector('.mobile-product-bar__add-button');
    
    if (!wrapper || !button) return;
    
    wrapper.dataset.variantId = variant.id;
    button.dataset.variantId = variant.id;

    const productPath = button.dataset.productPath || '';
    if (productPath && variant.id) {
      const normalizedPath = productPath.startsWith('/') ? productPath : `/${productPath}`;
      const productUrl = `${window.location.origin}${normalizedPath}?variant=${variant.id}`;
      button.dataset.productUrl = productUrl;
      button.setAttribute('data-product-url', productUrl);
    }

    const sku = variant.sku && String(variant.sku).trim() !== '' ? String(variant.sku).trim() : '';
    button.dataset.variantSku = sku;
    button.setAttribute('data-variant-sku', sku);

    setCartButtonAvailability(button, variant);
  }
  
  function getInventoryStatus(variant) {
    if (!variant) return 'out_of_stock';
    
    // Если есть полные данные варианта с inventory_management
    if (variant.inventory_management !== undefined) {
      if (variant.inventory_management === 'shopify') {
        const quantity = variant.inventory_quantity || 0;
        if (quantity > 0) {
          if (quantity <= 10) {
            return 'low';
          }
          return 'in_stock';
        } else {
          if (variant.inventory_policy === 'continue') {
            return 'in_stock';
          }
          return 'out_of_stock';
        }
      } else {
        return variant.available ? 'in_stock' : 'out_of_stock';
      }
    }
    
    // Если нет данных об inventory, используем available
    return variant.available ? 'in_stock' : 'out_of_stock';
  }
  
  function getSelectedSize() {
    try {
      const section = document.querySelector('[data-variants]')?.closest('.shopify-section');
      const variantPicker = section ? section.querySelector('variant-picker') : document.querySelector('variant-picker');
      
      if (variantPicker) {
        const sizeOptions = variantPicker.querySelectorAll('[data-option="Size"], [data-option="size"]');
        for (const option of sizeOptions) {
          if (option.matches('input:checked, option:selected, .selected, [aria-selected="true"]')) {
            return option.dataset.value || option.textContent?.trim();
          }
        }
      }
      return null;
    } catch {
      return null;
    }
  }
  
  function getProductMetafields() {
    try {
      const section = document.querySelector('[data-variants]')?.closest('.shopify-section');
      return {
        size: section?.querySelector('[data-product-size]')?.value?.trim() || '',
        material: section?.querySelector('[data-product-material]')?.value?.trim() || '',
        brand: section?.querySelector('[data-product-brand]')?.value?.trim() || ''
      };
    } catch (error) {
      return {};
    }
  }
  
  function getCollectionData() {
    try {
      const section = document.querySelector('[data-variants]')?.closest('.shopify-section');
      const title = section?.querySelector('[data-collection-title]')?.value?.trim() || '';
      const url = section?.querySelector('[data-collection-url]')?.value?.trim() || '';
      
      if (title && title !== '' && title !== '#') {
        return {
          title: title,
          url: url || '#'
        };
      }
      return null;
    } catch (error) {
      return null;
    }
  }

  function init() {
    document.addEventListener('variant:changed', (e) => {
      if (e.detail?.variant) {
        updateParameters(e.detail.variant.id, e.detail.variant);
      }
    });
    
    document.addEventListener('variant:update', (e) => {
      if (e.detail?.resource) {
        // Используем полный объект варианта из события
        updateParameters(e.detail.resource.id, e.detail.resource);
        
        // Обновляем inventory из HTML события
        if (e.detail?.data?.html) {
          updateInventoryFromHTML(e.detail.data.html);
          // Обновляем кнопку на ПК из HTML
          updateButtonFromHTML(e.detail.data.html);
        }
        
        // Обновляем кнопку преордера (мобильный бар и ПК через JS)
        updateMobileBarButton(e.detail.resource);
      }
    });
    
    document.addEventListener('change', (e) => {
      if (e.target.closest('variant-picker')) {
        const variantId = e.target.dataset.variantId || e.target.value;
        if (variantId) {
          // Пытаемся получить полные данные варианта из variant-picker
          const fullVariant = getFullVariantData(variantId);
          updateParameters(variantId, fullVariant);
        }
      }
    });

    const currentVariantId = new URLSearchParams(window.location.search).get('variant') || 
                            document.querySelector('input[name="id"]')?.value;
    if (currentVariantId) {
      requestAnimationFrame(() => {
        const fullVariant = getFullVariantData(currentVariantId);
        updateParameters(currentVariantId, fullVariant);
      });
    } else {
      requestAnimationFrame(() => {
        const variantsEl = document.querySelector('[data-variants]');
        if (variantsEl) {
          const variants = JSON.parse(variantsEl.textContent || '[]');
          if (variants.length > 0) {
            const fullVariant = getFullVariantData(variants[0].id);
            updateParameters(variants[0].id, fullVariant);
          }
        }
      });
    }
  }
  
  function getFullVariantData(variantId) {
    try {
      // Пытаемся получить полные данные варианта из variant-picker
      const variantPicker = document.querySelector('variant-picker');
      if (variantPicker) {
        const scriptEl = variantPicker.querySelector('script[type="application/json"]');
        if (scriptEl) {
          const fullVariant = JSON.parse(scriptEl.textContent || '{}');
          if (fullVariant && String(fullVariant.id) === String(variantId)) {
            return fullVariant;
          }
        }
      }
      
      // Если не нашли, возвращаем null
      return null;
    } catch {
      return null;
    }
  }
  
  function closeAllSharePopovers() {
    document.querySelectorAll('[data-product-share-popover]').forEach(function(popover) {
      popover.hidden = true;
      popover.style.position = '';
      popover.style.top = '';
      popover.style.right = '';
      popover.style.left = '';
      popover.style.width = '';
      popover.style.minWidth = '';
      popover.style.maxWidth = '';
      popover.style.zIndex = '';
    });
    document.querySelectorAll('[data-product-share]').forEach(function(shareBtn) {
      shareBtn.setAttribute('aria-expanded', 'false');
    });
  }

  function positionMobileSharePopover(shareBtn, popover) {
    if (!shareBtn || !popover) return;

    if (window.matchMedia('(min-width: 1041px)').matches) {
      popover.style.position = '';
      popover.style.top = '';
      popover.style.right = '';
      popover.style.left = '';
      popover.style.width = '';
      popover.style.minWidth = '';
      popover.style.maxWidth = '';
      popover.style.zIndex = '';
      return;
    }

    var rect = shareBtn.getBoundingClientRect();
    var margin = 14;
    var maxWidth = Math.min(240, window.innerWidth - margin * 2);

    popover.style.position = 'fixed';
    popover.style.top = Math.round(rect.bottom + 6) + 'px';
    popover.style.right = Math.round(Math.max(margin, window.innerWidth - rect.right)) + 'px';
    popover.style.left = 'auto';
    popover.style.width = 'max-content';
    popover.style.minWidth = '188px';
    popover.style.maxWidth = maxWidth + 'px';
    popover.style.zIndex = '100010';
  }

  function toggleSharePopover(shareBtn, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    var block = shareBtn.closest('.product-details__share-block');
    var popover = block ? block.querySelector('[data-product-share-popover]') : null;
    if (!popover) return;

    var willOpen = popover.hidden;
    closeAllSharePopovers();
    if (willOpen) openSharePopover(shareBtn);
  }

  function resetShareCopyLabel(copyBtn) {
    if (!copyBtn) return;
    copyBtn.disabled = false;
    var labelEl = copyBtn.querySelector('.product-details__share-popover-label');
    var defaultLabel = copyBtn.dataset.defaultLabel || copyBtn.getAttribute('data-default-label') || 'Copy link';
    if (labelEl) {
      labelEl.textContent = defaultLabel;
    } else {
      copyBtn.textContent = defaultLabel;
    }
  }

  function openSharePopover(shareBtn) {
    var block = shareBtn.closest('.product-details__share-block');
    var popover = block ? block.querySelector('[data-product-share-popover]') : null;
    var url = shareBtn.getAttribute('data-share-url') || '';
    if (!popover || !url) return;

    popover.dataset.shareUrl = url;
    popover.querySelectorAll('[data-product-share-copy]').forEach(resetShareCopyLabel);
    popover.hidden = false;
    shareBtn.setAttribute('aria-expanded', 'true');
    positionMobileSharePopover(shareBtn, popover);
  }

  function copyShareUrl(url, copyBtn) {
    if (!url) return;

    var copiedLabel = copyBtn.getAttribute('data-copied-label') || 'Copied!';
    var labelEl = copyBtn.querySelector('.product-details__share-popover-label');
    var defaultLabel = copyBtn.getAttribute('data-default-label') || copyBtn.dataset.defaultLabel || (labelEl ? labelEl.textContent : copyBtn.textContent);

    var onCopied = function() {
      if (labelEl) {
        labelEl.textContent = copiedLabel;
      } else {
        copyBtn.textContent = copiedLabel;
      }
      copyBtn.disabled = true;
      window.setTimeout(function() {
        copyBtn.disabled = false;
        closeAllSharePopovers();
      }, 800);
    };

    if (!copyBtn.dataset.defaultLabel) {
      copyBtn.dataset.defaultLabel = defaultLabel;
    }

    var copyWithFallback = function() {
      var textarea = document.createElement('textarea');
      textarea.value = url;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      textarea.style.top = '0';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      try {
        if (document.execCommand('copy')) onCopied();
      } catch (error) {
        console.warn('Failed to copy product URL with execCommand', error);
      } finally {
        document.body.removeChild(textarea);
      }
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(onCopied).catch(function(error) {
        console.warn('Failed to copy product URL to clipboard', error);
        copyWithFallback();
      });
      return;
    }

    copyWithFallback();
  }

  var lastShareTouchAt = 0;

  document.addEventListener('touchend', function(e) {
    var shareBtn = e.target.closest('[data-product-share]');
    if (!shareBtn) return;
    lastShareTouchAt = Date.now();
    toggleSharePopover(shareBtn, e);
  }, { passive: false, capture: true });

  document.addEventListener('click', function(e) {
    var shareItem = e.target.closest('[data-product-share-popover] a');
    if (shareItem) {
      closeAllSharePopovers();
      return;
    }

    var copyBtn = e.target.closest('[data-product-share-copy]');
    if (copyBtn) {
      e.preventDefault();
      e.stopPropagation();
      var popover = copyBtn.closest('[data-product-share-popover]');
      var url = popover ? popover.getAttribute('data-share-url') || popover.dataset.shareUrl || '' : '';
      if (!url) {
        var block = copyBtn.closest('.product-details__share-block');
        var shareBtn = block ? block.querySelector('[data-product-share]') : null;
        url = shareBtn ? shareBtn.getAttribute('data-share-url') || '' : '';
      }
      copyShareUrl(url, copyBtn);
      return;
    }

    var shareBtn = e.target.closest('[data-product-share]');
    if (shareBtn) {
      if (Date.now() - lastShareTouchAt < 700) return;
      toggleSharePopover(shareBtn, e);
      return;
    }

    if (!e.target.closest('[data-product-share-popover]')) {
      closeAllSharePopovers();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeAllSharePopovers();
  });

  window.addEventListener('resize', function() {
    document.querySelectorAll('[data-product-share][aria-expanded="true"]').forEach(function(shareBtn) {
      var block = shareBtn.closest('.product-details__share-block');
      var popover = block ? block.querySelector('[data-product-share-popover]') : null;
      if (popover && !popover.hidden) {
        positionMobileSharePopover(shareBtn, popover);
      }
    });
  }, { passive: true });

  window.addEventListener('scroll', function() {
    document.querySelectorAll('[data-product-share][aria-expanded="true"]').forEach(function(shareBtn) {
      var block = shareBtn.closest('.product-details__share-block');
      var popover = block ? block.querySelector('[data-product-share-popover]') : null;
      if (popover && !popover.hidden) {
        positionMobileSharePopover(shareBtn, popover);
      }
    });
  }, { passive: true, capture: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  document.addEventListener('shopify:section:load', init);
})();
